
import { UserEditResolver } from './../users/services/user.resolver.service';
import { UserService } from './../users/services/user.service';
import { UserModule } from '../users/user.module';
import {
    BusinessPortalListResolver, BusinessPortalEditResolver
    , PortalManagerUserlistResolver,
    PortalBusListResolver
} from './services/business-portal.resolver.service';
import { AppSharedModule } from './../shared/appShared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PortalComponent } from './portals.component';
import {
    PortalDetailsComponent,
    PortalListComponent,
    PortalFeaturesComponent,
    PortalWizardComponent,
    PortalUserComponent
} from './components/';
import { BusinessPortalService } from './services/business-portal.services';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { TableModule } from 'primeng/table';
import { SharedModule } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { PasswordValidatorModule } from 'src/app/shared/password-validator/password-validator.module';
@NgModule({ exports: [
        PortalComponent,
        PortalDetailsComponent,
        PortalListComponent,
        PortalFeaturesComponent,
        PortalWizardComponent,
        PortalUserComponent
    ],
    declarations:
        [
            PortalComponent,
            PortalDetailsComponent,
            PortalListComponent,
            PortalFeaturesComponent,
            PortalWizardComponent,
            PortalUserComponent
        ], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        DialogModule,
        RouterModule,
        TableModule,
        UserModule,
        ButtonModule,
        AppSharedModule,
        TranslatePipe, TranslateDirective,
        CheckboxModule,
        ConfirmDialogModule,
        PasswordValidatorModule
    ],
    providers: [BusinessPortalService, BusinessPortalListResolver,
        BusinessPortalEditResolver,
         UserService, UserEditResolver,
         PortalManagerUserlistResolver, PortalBusListResolver, provideHttpClient(withInterceptorsFromDi())]
})
export class PortalModule { }
